import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import Loader from 'components/Loader';
import useOnlineStatus from 'hooks/useOnlineStatus';
import { useSnackbar } from 'hooks/useSnackbar';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function ApiStatus() {
  const { showSnackbar } = useSnackbar();
  const isOnline = useOnlineStatus();
  const { t } = useTranslation('task');
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();

  const getSnackBarText = useCallback(() => {
    // if (isInternetIssue) {
    //   return `${t('somethingWentWrongTryAgain')}`;
    // }
    return `${t('checkInternetConnection')}`;
  }, [t]);

  useEffect(() => {
    if (!isOnline) {
      showSnackbar(getSnackBarText());
    }
  }, [isOnline, showSnackbar, getSnackBarText]);

  const isLoading = isFetching > 0 || isMutating > 0;

  return isLoading && <Loader />;
}
export default ApiStatus;
